module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-6.9d1a6bab.JPG";